import template from './loansSignUpModal.html';
import controller from './loansSignUpModal.controller';
import './loansSignUpModal.scss';

let loansSignUpModalComponent = {
  restrict: 'E',
  bindings: {
    error: '<',
    loan: '<',
    message: '<',
    isMobileApp: '<',
    onClick: '&'
  },
  template,
  controller
};

export default loansSignUpModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpModal/loansSignUpModal.component.js